<div class="container-fluid">
    <mat-card style="margin-bottom: 15px">
        <div class="actions">
            <div class="rounded border p-10 w-100">
                <h2>{{ "BILLET.filters" | translate }}</h2>
                <div class="filters">
                    <mat-form-field appearance="fill" class="date-range">
                        <mat-label>{{ "BILLET.due_date_range" | translate }}</mat-label>
                        <mat-date-range-input [formGroup]="range" [rangePicker]="pickerRangeDate">
                            <input
                                matStartDate
                                [placeholder]="'BILLET.start' | translate"
                                formControlName="dateStart"
                            />
                            <input matEndDate [placeholder]="'BILLET.final' | translate" formControlName="dateFinal" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="pickerRangeDate"></mat-datepicker-toggle>
                        <mat-date-range-picker #pickerRangeDate [disabled]="_loaderService.isLoading | async"
                            ><mat-date-range-picker-actions>
                                <button mat-button matDateRangePickerCancel>
                                    {{ "BILLET.cancel" | translate }}
                                </button>
                                <button
                                    mat-raised-button
                                    color="primary"
                                    matDateRangePickerApply
                                    (click)="onRangeDateApply()"
                                >
                                    {{ "BILLET.apply" | translate }}
                                </button>
                            </mat-date-range-picker-actions></mat-date-range-picker
                        >
                    </mat-form-field>

                    <mat-form-field appearance="fill" [floatLabel]="'auto'">
                        <mat-label>{{ "BILLET.period" | translate }}</mat-label>
                        <mat-select
                            [disabled]="_loaderService.isLoading | async"
                            [(value)]="dueDateInBatchesParams.periodId"
                            (valueChange)="onPeriodChange($event)"
                            required
                        >
                            <mat-option *ngFor="let period of periodList" [value]="period.periodId">
                                {{ period.description }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <div class="buttonInRounded">
                        <button
                            mat-raised-button
                            color="accent"
                            (click)="onCleanFilter()"
                            [disabled]="_loaderService.isLoading | async"
                        >
                            <mat-icon>clear</mat-icon>{{ "BILLET.clear" | translate }}
                        </button>
                    </div>
                    <div class="buttonInRounded">
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="onSearch()"
                            [disabled]="
                                (_loaderService.isLoading | async) ||
                                dueDateInBatchesParams.dueDateStart == '' ||
                                dueDateInBatchesParams.periodId == ''
                            "
                        >
                            <mat-icon>search</mat-icon> {{ "BILLET.search" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="rounded border p-10" *ngIf="lines.length > 0">
                <h2>{{ "BILLET.changes" | translate }}</h2>
                <div class="new-due-date">
                    <mat-form-field appearance="fill">
                        <mat-label>{{ "BILLET.new_due_date" | translate }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="nDD"
                            [formControl]="newDueDateForm"
                            [matDatepickerFilter]="filterNewDueDate"
                        />
                        <mat-datepicker-toggle matSuffix [for]="nDD"></mat-datepicker-toggle>
                        <mat-datepicker
                            #nDD
                            [disabled]="(_loaderService.isLoading | async) || filtersAltered"
                        ></mat-datepicker>
                    </mat-form-field>
                    <div class="buttonInRounded">
                        <button
                            mat-button
                            mat-raised-button
                            [matMenuTriggerFor]="alterMenu"
                            color="primary"
                            [disabled]="
                                (_loaderService.isLoading | async) ||
                                lines.length == 0 ||
                                newDueDateForm.value == '' ||
                                filtersAltered
                            "
                        >
                            <mat-icon>event_available</mat-icon>{{ "BILLET.alter" | translate }}
                        </button>
                        <mat-menu #alterMenu="matMenu">
                            <button mat-menu-item (click)="onAlterDueDate(true)">
                                {{ "BILLET.alter_all" | translate }}
                            </button>
                            <button mat-menu-item (click)="onAlterDueDate()" [disabled]="billetsSelected.length == 0">
                                {{ "BILLET.alter_selecteds" | translate }}
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="resOk && lines.length > 0" style="margin-top: 15px">
            <simple-list
                [data]="lines"
                [config]="simpleTableConfig"
                (reloadTable)="onReloadTable($event)"
                (resSelectLine)="onResSelectLine($event)"
            >
            </simple-list>
        </div>

        <div *ngIf="resOk && lines.length == 0">
            <mat-card class="p-10" style="margin-top: 15px">
                <p class="notData">{{ "BILLET.thereIsNoDataToLoad" | translate }}</p>
            </mat-card>
        </div>

        <loader></loader>
    </mat-card>
</div>
